import {
  forwardRef,
  isValidElement,
  cloneElement,
  type HTMLProps,
} from "react";
import { useMergeRefs } from "@floating-ui/react";

import { useTooltipContext } from "../Tooltip";

const TooltipTrigger = forwardRef<HTMLElement, HTMLProps<HTMLElement>>(
  (props, ref) => {
    const { children, ...otherProps } = props;

    const { open, floatingData, interactionsData } = useTooltipContext();
    const childrenRef = (children as any).ref;

    const mergedRefs = useMergeRefs([
      floatingData.refs.setReference,
      childrenRef,
      ref,
    ]);

    if (!isValidElement(children)) {
      return null;
    }

    return cloneElement(
      children,
      interactionsData.getReferenceProps({
        ref: mergedRefs,
        ...otherProps,
        ...children.props,
        "data-state": open ? "open" : "closed",
      })
    );
  }
);

TooltipTrigger.displayName = "TooltipTrigger";

export default TooltipTrigger;
